import { styled } from "styled-components";

export const StyledWrapper = styled.div`
  z-index: 10;
  margin-bottom: 40px;
  color: #242f38;
`;
